import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../../services/ApiService";
import DatePicker, {getDay} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import * as Yup from "yup";

export default function CreateLeaveRequestModal({
  closeModal,
  alert,
  requestType,
  getRequest,
}) {
  const [reqType, setRequestType] = useState("");
  const [req, setReq] = useState({});

  // console.log("ssss", req);
  // const addMonth = async (requestId) => {
  //   console.log("ids", requestId);
  //   let reqqTypes = await requestType.find(
  //     (req_type) => req_type.id === requestId
  //   );
  //   // console.log("requestType", reqqTypes);

  //   // let day = new Date();
  //   // day.setDate(day.getDate() + num);
  //   // return day;
  // };
  const getFirstDate = () => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };

  // const cal = (start_date, numOfDays) => {
  //   console.log(start_date + "------" + numOfDays);
  //   let calc_leave_req = new Date(start_date);
  //   calc_leave_req.setDate(
  //     calc_leave_req.getDate() + numOfDays ? numOfDays : 0
  //   );
  //   return calc_leave_req;
  // };

  // const getLastDate = () => {
  //   const date = new Date();
  //   return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  // };

  // const getFirstDateNextMonth = (num) => {
  //   let date = new Date();
  //   let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  //   lastDay.setDate(lastDay.getDate() + 1);
  //   return lastDay;
  // };
  // const new_date = new Date()
  const date = new Date();
  const isWeekday = (date) => {
    const day = date.getDay(date);
    return day !== 0 && day !== 6;
  }

  const handleReqChnage = (event) => {
    const reqId = event.target.value;
    console.log("id", reqId);
    const foundRequest = requestType.find((req) => req.id === reqId);
    console.log("found", foundRequest);
    setRequestType(reqId);
    setReq(foundRequest);
  };

  return (
    <React.Fragment>
      <div className="">
        <h4 className="modal-title w-100" style={{ color: "#000" }}>
          Create Leave Request
        </h4>
        <hr />
      </div>
      <Formik
        initialValues={{ request_type: "", start_date: "", end_date: "" }}
        // validationSchema={Yup.object({
        //   request_type: Yup.string().required("Leave type should not be empty"),
        // })}
        onSubmit={async (values, { setSubmitting }) => {
          values.request_type = reqType;
          const start_date = new Date( values.start_date.getTime() + Math.abs(values.start_date.getTimezoneOffset()*60000))

          const end_date = new Date( values.end_date.getTime() + Math.abs(values.end_date.getTimezoneOffset()*60000))
        
          values.start_date = start_date;
          values.end_date = end_date;
          try {
            const res = await ApiService.post(
              "leave-requests/create-leave-request",
              values
            );
            if (res.data.type === false) {
              alert.error(res.data.msg);
              setSubmitting(false);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
            }
            getRequest();
            closeModal();
          } catch (error) {
          }
        }}
      >
        {({
          handleSubmit,
          values,
          isSubmitting,
          setFieldValue,
          handleChange,
          touched,
          errors,
        }) => (
          <Form className="mt-2">
            <div className="form-group">
              <label>
                {" "}
                Leave Type<span className="text-danger"> * </span>
              </label>
              <select
                typr="text"
                className="form-control"
                id="request_type"
                name="reqType"
                onChange={handleReqChnage}
                // onChange={(e) => setRequestType(e.target)}
                value={reqType}
                required
              >
                <option value="">--Select Leave type--</option>

                {requestType.map((leave, i) => (
                  <option value={leave.id} key={i}>
                    {leave.type}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>
                {" "}
                Start Date <span className="text-danger"> * </span>
              </label>
              <DatePicker
                selected={values.start_date}
                minDate={new Date()}
                // minDate={addMonth(reqType)}
                // maxDate={addMonth(9)}
                showDisabledMonthNavigation
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="start_date"
                autoComplete="off"
                filterDate={isWeekday}
                onChange={(date) => setFieldValue("start_date", date)}
                required
              />
            </div>
            <div className="form-group">
              <label>
                {" "}
                End Date <span className="text-danger"> * </span>
              </label>
              <DatePicker
                selected={values.end_date}
                minDate={new Date()}
                // maxDate={addMonth(9)}
                // showDisabledMonthNavigation
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="end_date"
                autoComplete="off"
                filterDate={isWeekday}
                onChange={(date) => setFieldValue("end_date", date)}
                required
              />
            </div>
            <hr />

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/holidaymanagement/modal/create_leave_request.js